import { Box } from '@mantine/core';
import { keyframes } from '../utils/keyframes';
import { forwardRef } from 'react';
import { useReducedMotion } from '../hooks';

export interface JelloProps {
  children: React.ReactNode;
  active?: boolean;
  duration?: number;
  infinite?: boolean;
  count?: number;
}

const jelloKeyframes = keyframes({
  '0%, 11.1%, 100%': { transform: 'translate3d(0, 0, 0)' },
  '22.2%': { transform: 'skewX(-12.5deg) skewY(-12.5deg)' },
  '33.3%': { transform: 'skewX(6.25deg) skewY(6.25deg)' },
  '44.4%': { transform: 'skewX(-3.125deg) skewY(-3.125deg)' },
  '55.5%': { transform: 'skewX(1.5625deg) skewY(1.5625deg)' },
  '66.6%': { transform: 'skewX(-0.78125deg) skewY(-0.78125deg)' },
  '77.7%': { transform: 'skewX(0.390625deg) skewY(0.390625deg)' },
  '88.8%': { transform: 'skewX(-0.1953125deg) skewY(-0.1953125deg)' },
});

const Jello = forwardRef<HTMLDivElement, JelloProps>(
  (
    {
      children,
      active = true,
      duration = 1000,
      infinite = false,
      count = 1,
    },
    ref
  ) => {
    const reducedMotion = useReducedMotion();

    if (reducedMotion || !active) {
      return <Box ref={ref}>{children}</Box>;
    }

    const iterationCount = infinite ? 'infinite' : count;

    return (
      <Box
        ref={ref}
        style={{
          animation: `${jelloKeyframes} ${duration}ms ease-in-out ${iterationCount}`,
          transformOrigin: 'center',
          display: 'inline-block',
        }}
      >
        {children}
      </Box>
    );
  }
);

Jello.displayName = 'Jello';

export default Jello;
